import { useLoading, ToastAlertTypes } from '@genial/components';
import { ErrorListResponse, instanceOfErrorListResponse, Service } from '@genial/services';
import { useNavigation } from '@react-navigation/native';
import { useState } from 'react';

import { useToastCreator } from '../../../../../hooks/useToastCreator';

interface useCancelOrderProps {
  orderId: string;
}

const loadingCancelOrderMessage = {
  title: 'Aguarde enquanto estamos cancelando sua ordem.',
  description: 'Este processo pode levar alguns segundos, não saia desta pagina.',
};

const errorCancelOrderMessage: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Opa! Algo parece errado.',
  'Ocorreu um erro ao cancelar ordem,\nverifique sua conexão com a internet e\ntente novamente em instantes.',
];

const successCancelOrderMessage: [ToastAlertTypes.Type, string, string] = [
  'success',
  'Tudo certo!',
  'A ordem foi cancelada com sucesso!',
];

const screenName = 'order-history';

export const useCancelOrder = ({ orderId }: useCancelOrderProps) => {
  const { hide, show } = useLoading();
  const { showToast, showToastFromError } = useToastCreator('toast-cancel-order');
  const { canGoBack, goBack } = useNavigation();

  const [cancelOrderModalIsOpen, setCancelOrderModalIsOpen] = useState(false);

  const handleCancelEquityOrder = async () => {
    try {
      show(loadingCancelOrderMessage);

      await Service.Equities.V1.putOrdersCancel({
        screenName,
        equityOrderCancelRequest: { orderId },
      });

      showToast(...successCancelOrderMessage);
      setCancelOrderModalIsOpen(false);
      if (canGoBack()) {
        goBack();
      }
    } catch (error) {
      if (instanceOfErrorListResponse(error as object)) {
        (error as ErrorListResponse).errors?.forEach((errorItem) => showToastFromError(errorItem));
        return;
      }

      showToast(...errorCancelOrderMessage);
    } finally {
      hide();
    }
  };

  const handleChangeCancelOrderModalState = (value: boolean) => setCancelOrderModalIsOpen(value);

  return { handleCancelEquityOrder, handleChangeCancelOrderModalState, cancelOrderModalIsOpen };
};
